export class Circle {

    constructor() {
        this.x = 0;
        this.y = 0;
        this.radius = 0;
    }

    /**
     * @param {Circle} circle 
     */
    touching(circle) {
        const xDist = this.x - circle.x;
        const yDist = this.y - circle.y;
        const sqDist = xDist * xDist + yDist * yDist;

        const minDist = this.radius + circle.radius;

        return sqDist < minDist * minDist;
    }

    sqDistToPoint(point) {
        const xDist = this.x - point.x;
        const yDist = this.y - point.y;
        const sqDist = xDist * xDist + yDist * yDist;
        return sqDist;
    }

    /**
     * @param {CanvasRenderingContext2D} context 
     */
    render(context) {
        context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
    }

    getPoints(numPoints) {
        // TODO: cache this?
        const points = [];
        for (let i = 0; i < numPoints; i++) {
            const amt = i / numPoints;
            const angle = 2 * Math.PI * amt;
            points.push({
                x: this.x + this.radius * Math.cos(angle),
                y: this.y + this.radius * Math.sin(angle),
            });
        }
        return points;
    }

}


// WEBPACK FOOTER //
// ./src/js/circle.js